interface UniaConfig {
  MAIN_DOMAIN: string;
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  ASSISTENTUS_API_URL: string;
  NOTES_API_URL: string;
  TASK_API_URL: string;
  CVS_API_URL: string;
  SECRETARY_API_URL: string;
}

const w = window as unknown as { __UNIA_CONFIG__?: Partial<UniaConfig> };
const runtimeCfg = w.__UNIA_CONFIG__ || {};

const mainDomain =
  runtimeCfg.MAIN_DOMAIN ||
  import.meta.env.VITE_MAIN_DOMAIN ||
  'unia.one';

const config: UniaConfig = {
  MAIN_DOMAIN: mainDomain,
  SUPABASE_URL:
    runtimeCfg.SUPABASE_URL ||
    import.meta.env.VITE_SUPABASE_URL ||
    `https://api.${mainDomain}`,
  SUPABASE_ANON_KEY:
    runtimeCfg.SUPABASE_ANON_KEY ||
    import.meta.env.VITE_SUPABASE_ANON_KEY ||
    '',
  ASSISTENTUS_API_URL:
    runtimeCfg.ASSISTENTUS_API_URL ||
    import.meta.env.VITE_ASSISTENTUS_API_URL ||
    `https://assistentus.${mainDomain === 'unia.one' ? 'com' : mainDomain}/api`,
  NOTES_API_URL:
    runtimeCfg.NOTES_API_URL ||
    import.meta.env.VITE_NOTES_API_URL ||
    `https://notes-api.${mainDomain}`,
  TASK_API_URL:
    runtimeCfg.TASK_API_URL ||
    import.meta.env.VITE_TASK_API_URL ||
    `https://task.${mainDomain}`,
  CVS_API_URL:
    runtimeCfg.CVS_API_URL ||
    import.meta.env.VITE_CVS_API_URL ||
    `https://cvs-api.${mainDomain}`,
  SECRETARY_API_URL:
    runtimeCfg.SECRETARY_API_URL ||
    import.meta.env.VITE_SECRETARY_API_URL ||
    `https://secretary-api.${mainDomain}`,
};

export default config;
